import { Typography } from '@mui/material';

interface UnsupportedChangeReferralMessageProps {
	/** Brand contact number shown in the call-to-action. */
	phoneNumber: string;
	/** Brand opening hours shown after the call-to-action. */
	openingHours: string;
}

/** Body copy for MTA referral when a change cannot be quoted. */
export const UnsupportedChangeReferralMessage = ({
	phoneNumber,
	openingHours,
}: UnsupportedChangeReferralMessageProps) => (
	<Typography variant='h6' fontWeight='lighter'>
		Thank you for your interest. Unfortunately, we are unable to provide a quote for this change because it&apos;s not
		something your current policy can cover. If this change is required, you&apos;ll need to cancel your current policy.
		To cancel, or discuss further, please give us a call on <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>. Our
		opening hours are {openingHours}. To confirm, no changes have been made to your policy. It is important that your
		details are up to date and accurate so you are covered in the event of a claim.
	</Typography>
);
